import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none;stroke:#000000;stroke-width:1.7;stroke-miterlimit:10}.__st1{clip-path:url(#__SVGID_2_)}.__st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st3{fill:none}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g><path d=\"M30.63,35.03H8.8V14.29h21.83c5.72,0,10.37,4.65,10.37,10.37S36.35,35.03,30.63,35.03z M10.8,33.03h19.83\r\n\t\tc4.61,0,8.37-3.75,8.37-8.37s-3.75-8.37-8.37-8.37H10.8V33.03z\"></path><rect x=\"28.84\" y=\"15.29\" width=\"2\" height=\"18.74\"></rect><rect x=\"14.8\" y=\"18.97\" width=\"9.86\" height=\"2\"></rect><rect x=\"14.8\" y=\"23.68\" width=\"9.86\" height=\"2\"></rect><rect x=\"14.8\" y=\"28.14\" width=\"9.86\" height=\"2\"></rect><path d=\"M10.8,29.68H4v-9.41h6.8V29.68z M6,27.68h2.8v-5.41H6V27.68z\"></path><path d=\"M24.12,16.29h-9V9.97h9V16.29z M17.12,14.29h5v-2.32h-5V14.29z\"></path></g>", 1))
  ]))
}
export default { render: render }